import {
  TableActionBarButton,
  TableActionBarRoot,
  TableActionBarRowsSelected,
} from "@/components/shared/data-table/action-bar";
import { TypeSelect } from "@/features/invoice-overview/invoice-table-action-bar";
import type {
  InvoiceType,
  InvoiceTypeString,
} from "@/lib/constants/invoice-type";
import type { Table } from "@tanstack/react-table";
import { Paperclip, Trash2 } from "lucide-react";
import { useTranslation } from "react-i18next";

type Props = {
  table: Table<any>;
  onDelete: (invoiceIds: string[]) => void | Promise<void>;
  onReview: (invoiceIds: string[]) => void | Promise<void>;
  onTypeChange: (
    invoiceIds: string[],
    type: InvoiceType,
  ) => void | Promise<void>;
  invoiceType?: InvoiceTypeString;
};

export const TableActionBar = ({
  table,
  onDelete,
  onReview,
  onTypeChange,
  invoiceType,
}: Props) => {
  const { t } = useTranslation();

  if (table.getSelectedRowModel().rows.length === 0) return null;

  const handleReview = () => {
    onReview(table.getSelectedRowModel().rows.map((row) => row.id));
  };

  const handleDelete = () => {
    onDelete(table.getSelectedRowModel().rows.map((row) => row.id));
  };

  const handleTypeChange = (type: InvoiceType) => {
    onTypeChange(
      table.getSelectedRowModel().rows.map((row) => row.id),
      type,
    );
  };

  return (
    <TableActionBarRoot>
      <TableActionBarRowsSelected table={table} />
      <TypeSelect currentType={invoiceType} onSelect={handleTypeChange} />
      <TableActionBarButton variant="outline" onClick={handleDelete}>
        <Trash2 className="w-4 h-4" />
        {t("delete")}
      </TableActionBarButton>
      <TableActionBarButton onClick={handleReview}>
        <Paperclip className="w-4 h-4" />
        {t("not_a_booking")}
      </TableActionBarButton>
    </TableActionBarRoot>
  );
};
